import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import MUIAutoComplete from '../../customComponents/MUIAutoComplete'
import { Modal } from '../../customComponents/Modal'
import type { SelectableOrganization } from '../../../models/SelectableOrganization'

interface Props {
  options: SelectableOrganization[]
  onClose: () => void
  onConfirm: (organization: SelectableOrganization) => void
}

export const AddOrganizationModal = (props: Props): JSX.Element => {
  const [selected, setSelected] = useState<SelectableOrganization | undefined>(undefined)

  return <Modal
    open={true}
    title='Add Organization'
    confirmButtonText='Add Organization'
    cancelButtonText='Cancel'
    isUpdateDisabled={selected == null}
    onClose={props.onClose}
    onCancel={props.onClose}
    onConfirm={() => { if (selected != null) props.onConfirm(selected) }}
    bodyContent={
      <Box sx={{ minWidth: '20em', py: '1em' }}>
        <Typography variant='body1' sx={{ mb: '1em' }}>
          Which organization should this user be added to?
        </Typography>

        <MUIAutoComplete
          separateLabel={true}
          label='Organization'
          name='organization'
          value={selected}
          options={props.options}
          dataTestId='organizationSelect'
          groupBy={(option: SelectableOrganization) => option.type}
          onChange={(_e, value) => {
            setSelected(props.options.find((o) => o.id === value?.id))
          }}
        />
      </Box>
    }
  />
}
